export enum PartnerId {
  VELO_BANK = "283"
}
